import { ethers } from 'ethers';
import {getCoachDetails, getRacerDetails} from './apihandler.js';
import padlock from '../../images/padlock.png';
//import { parseBytes32String } from 'ethers/lib/utils.js';
import {getPearlContractRO, returnAlch, getAccountContractRO,  getReadOnlyProvider, getNFTContractRO, getPRContractForCalls, getNFTCollectionRO, getCollectionByAddress, getAccContractForCalls, getProxyContractForCalls, pearlcontractadd, stakingcontractadd, stakingcontracttwoadd, getProxyContractRO, getStakingContractRO, getStakingContractOtherRO,getCoachContractRO, getStakingContractForCalls, getStakingContractOtherForCalls, getCoachContractForCalls,getEORContractForCalls, returnContract, returnAccContract, getTOSContractRO, getTOSContractForCalls} from './providers.js';

    const alchemy = returnAlch();
  //  const contract = getPearlContractRO();
    const tiers = require('../json/tiers.json');
    const speedBase = 10;
    const accelBase = 5;
    const endurBase = 3;

    const getCurrentMatic = async (walletAddress) => {
        const prov = await getReadOnlyProvider();
        let balance = await prov.getBalance(walletAddress);
        balance = parseFloat(balance / 1000000000000000000).toFixed(4);
 
        return balance;
    }

    const getCurrentWeek = async() => {
        const stakecontract = await getStakingContractRO();
        let week =  await stakecontract.currentWeek();
        return week;
    }

    const getPearlBalance = async(walletAddress) => {
        //const pearlcontract = await getPearlContractRO();
        let pearlbalance = await alchemy.core.getTokenBalances(walletAddress, [pearlcontractadd]); //await pearlcontract.balanceOf(walletAddress);
        const adjustpearlbalance = ethers.formatEther(pearlbalance.tokenBalances[0].tokenBalance);
        //pearlbalance = ethers.utils.formatEther(pearlbalance);
        return adjustpearlbalance;
    }

    const getNFTS = async(walletAddress, nftcontract) => {
        const nftcontracts = await getNFTContractRO(nftcontract);
        let racearray = await nftcontracts.tokensOfOwner(walletAddress);

        return racearray;
    }

    const checkAllTransferStatus = async(walletAddress) => {
        const nftcontract = await getNFTContractRO(returnContract());
        let racearray = await nftcontract.isApprovedForAll(walletAddress, returnAccContract());

        return racearray;
    }

    const setAllTransferStatus = async(allowed) => {
        const nftcontract = await getEORContractForCalls();
        let updateTransferStatus = await nftcontract.setApprovalForAll(returnAccContract(), allowed);

        let resp = '';
        try{
        const updateResultsResp = await updateTransferStatus.wait();
        resp = updateResultsResp;
        }catch (ex) {
            if (ex.code === "ACTION_REJECTED"){
                resp = undefined;
            }else{
                resp = ex;
            }
            
        }

        return resp;
    }

    const getMintBalance = async(walletAddress) => {
        const mintcontract = await getProxyContractRO();
        let availmints = await mintcontract.mintOptions(walletAddress)

        return availmints;   
    }

    const getRegistrationStatus = async(_league) => {
        const stakecontract = await getStakingContractRO();
        let status = await stakecontract.paused(_league);
        return status;
    }

    const getSetCoaches = async(_account) => {
        const stakecontract = await getStakingContractOtherRO();
        let coaches = await stakecontract.returnCoaches(_account);
        return coaches;
    }



   
    const getRoles = async(_week, _league, _account) => {
        const stakeContract = await getStakingContractOtherRO();
    //    const nameContract = await getAccountContractRO();
    //    let captain = await nameContract.getCaptain(_account);
    //    let capObj = {};
	//	capObj.id = parseInt(captain[0]);
	//	capObj.contract = (captain[1] === '0x72106Bbe2b447ECB9b52370Ddc63cfa8e553B08C' ? '1' : '2');
        _week = (parseInt(_week) === 108 ? 107 : _week );
        let roleCall = await stakeContract.walletByWeek(_league, _week, _account);
        let roles = {};
        let anch = parseInt(roleCall.wAnchor);
				let vc = parseInt(roleCall.wAssistant);
				let equip = parseInt(roleCall.wEquip);
				let bench = parseInt(roleCall.wBench)
                let cap = parseInt(roleCall.wCaptain);
                let capObj = {};
                capObj.id = cap
                capObj.contract = (roleCall.captainContract === '0x72106Bbe2b447ECB9b52370Ddc63cfa8e553B08C' ? '1' : '2');
				let anchObj = {};
				anchObj.id = anch;
				anchObj.contract = (roleCall.anchorContract === '0x72106Bbe2b447ECB9b52370Ddc63cfa8e553B08C' ? '1' : '2');
				let assistObj = {};
				assistObj.id = vc;
				assistObj.contract = (roleCall.assistContract === '0x72106Bbe2b447ECB9b52370Ddc63cfa8e553B08C' ? '1' : '2');
				let equipObj = {};
				equipObj.id = equip;
				equipObj.contract = (roleCall.equipContract === '0x72106Bbe2b447ECB9b52370Ddc63cfa8e553B08C' ? '1' : '2');
				let benchObj = {};
				benchObj.id = bench;
				benchObj.contract = (roleCall.benchContract === '0x72106Bbe2b447ECB9b52370Ddc63cfa8e553B08C' ? '1' : '2');
        roles.anchObj = anchObj;
        roles.assistObj = assistObj;
        roles.equipObj = equipObj;
        roles.benchObj = benchObj;        
        roles.capObj = capObj;
        roles.manageStyle = roleCall.managementStyle;
        return roles;
    }

    const setRoles = async(tokens, contracts, boosts, league, currentAccount, pearlTotal) => {
        const stakecontract = await getStakingContractOtherForCalls();
        let resp;


        const pearlContractRO = await getPearlContractRO();
        let pearlallowance = await pearlContractRO.allowance(currentAccount, stakingcontracttwoadd);
        console.log(ethers.formatEther(pearlallowance));
        console.log(pearlTotal);
       
        try{

            if (parseInt(ethers.formatEther(pearlallowance)) < pearlTotal) {
                const pearlContract = await getPRContractForCalls();
                let tmz = await pearlContract.approve(stakingcontracttwoadd, ethers.parseEther((pearlTotal).toString()));
                let pcResults =  await tmz.wait();
                console.log(pcResults);
            }

            let updateRoles = await stakecontract.setBoost(boosts, tokens, contracts, league);
            //updateRoles = await stakecontract.setBoost(boosts, tokens, contracts, league);
            const updateRolesResp = await updateRoles.wait();
            resp = updateRolesResp;
            }catch (err) {
                console.log(err);
                if (err.code === "ACTION_REJECTED"){
                    resp = undefined;
                }else{
                    console.log(stakecontract.interface.parseError(err.data));
                    let errdata = stakecontract.interface.parseError(err.data).name;
                    resp = errdata;
                }
                
            }
            return resp;

    }

    const getStakedRacers = async() => {
        const stakecontract = await getStakingContractRO();
        let racers = await stakecontract.returnRacers();
        let racerarray = [];
        for (let x = 0; x < racers.length; x++) {   
            if (parseInt(racers[x].id) === 0 || parseInt(racers[x].eventWanted) === 100){
                continue;
            }
            racerarray.push(racers[x]);
        }
        return racerarray;
    }

    const getRacers = async(walletAddress, nftcontract, selectedCoach, weatherInfo, currWeek) => {

        let racearray = await getNFTS(walletAddress, nftcontract);
        let racers = [];
        let raceObj = {};
        let selCoachInfo = {};
        let newracearr = racearray.map(x => parseInt(x));
        const collectioninfo = getCollectionByAddress(nftcontract);
        let advTrait = weatherInfo.advantage;
        let coachesAll;
        let racersAll;
        let anch = [0,0,0,0];
        let vc = [0,0,0,0];
        let equip = [0,0,0,0];
        let bench = [0,0,0,0]; 
        let capt =[0,0,0,0];
        let manageSty = [0,0,0,0];

        if (collectioninfo.collection === "Coach"){
            //newracearr.push(313);
        }
        newracearr.sort(function(a, b){return a - b});
        if (racearray.length > 0){
            coachesAll = await getCoachDetails();
            if (collectioninfo.collection === "Racer" || collectioninfo.collection === "Custom"){
				let racersTemp = await getRacerDetails();
                
                racersAll = racersTemp.filter(x => x.Contract === (collectioninfo.collection === "Racer" ? "1" : "2"));
                selCoachInfo = coachesAll[selectedCoach-1];
                for (let x = 1; x < 4; x++){
                    let roles = await getRoles(currWeek, x, walletAddress);
                    anch[x] = roles.anchObj;
                    vc[x] = roles.assistObj;
                    equip[x] = roles.equipObj;
                    bench[x] = roles.benchObj; 
                    capt[x] = roles.capObj;
                    manageSty[x] = parseInt(roles.manageStyle);
                    
                }
                
            }
        }
        
        for (let i = 0; i < newracearr.length; i++){
            raceObj.collection = collectioninfo.collection;
            raceObj.id = newracearr[i];
            if (collectioninfo.collection === "Coach") {
             //   let tokenURI = await getCoachID(newracearr[i], nftcontract)
             //   let ind = tokenURI.indexOf("&b=") + 3;
			 //		let proxyId = tokenURI.slice(ind);
                    let rps = coachesAll[newracearr[i] - 1].Reef_Points;
                    let rank = coachesAll[newracearr[i] - 1].Rank;
                    let label = coachesAll[newracearr[i] - 1].Label;
                    let phantskin = coachesAll[newracearr[i] - 1].Phant_Skin;
                    let ocean = coachesAll[newracearr[i] - 1].Ocean;
                    let hemi = coachesAll[newracearr[i] - 1].Hemisphere;
                    let prestige = coachesAll[newracearr[i] - 1].Prestige;
                    let ranklabel = (rank === "0" ? 'Rookie' : (rank === "1" ? 'Veteran' : (rank === "2" ? 'Elite' : 'Legendary')));
                    let seclabel = coachesAll[newracearr[i] - 1].Secondary;
                raceObj.image = collectioninfo.imagepath + newracearr[i] + '.png';
                raceObj.rank = ranklabel;
                raceObj.ranknumber = rank;
                raceObj.label = label + (rank === "2" ? " Division" : "");
                raceObj.phantskin = phantskin;
                raceObj.reefpoints = rps;
                raceObj.ocean = ocean;
                raceObj.hemisphere = hemi;
                let level = 0;
                let baseboost = "+" + (rank === "0" ? "1" : "2") + " Speed " + label;
                let baseboostshrt = <span><b>+{(rank === "0" ? "1" : "2") + "S"}</b> {label}</span>;
                let legboost = "";
                let legboostshrt = "";
                let tiertwoboost = "";
                let tiertwoboostshrt = "";
                let tierfiveboost = "";
                let tierfiveboostshrt = "";
                let oceanboostshrt;
                if (rank === 3){
                    legboost = "+2 Speed Mythic & Legendary";
                    legboostshrt = <span><b>+2S</b> Mythic & Legendary</span>
                    if (phantskin === "Gold") {
                        phantskin = "All";
                    }
                }
                let skinboost = "";
                let skinboostshrt = "";

                let oceanboost = "";
                let hemiboost = "";
                let hemiboostshrt = "";
                if (rps >= 10){
                    level = 1;
                    skinboost = "+1 Speed " + phantskin + (phantskin === 'All' ? '' : ' skin');
                    skinboostshrt = <span><b>+1S</b> {phantskin + (phantskin === 'All' ? '' : ' skin')}</span>
                }else{
                    skinboost = <span style={{color:'grey'}}>+1 Speed {phantskin + (phantskin === 'All' ? ' ' : ' skin ')}  +{10 - rps} rps. <img src={padlock} style={{width:'15px'}} alt="locked"/></span>;
                    skinboostshrt = <span style={{color:'grey'}}><b>+1S</b> {phantskin + (phantskin === 'All' ? '' : ' skin')} +{10 - rps} rps. <img src={padlock} style={{width:'15px'}} alt="locked"/></span>
                }
                if (rps >= 50 || prestige >= 2){
                    level = 2;
                    tiertwoboost = "+1 Speed " + label + " Tier " + (rank < 3 ? parseInt(rank) + 1 : rank) ;
                    tiertwoboostshrt = <span><b>+1S</b> {label + " Tier " + (rank < 3 ? parseInt(rank) + 1 : rank)}</span>
                } else {
                    tiertwoboost = <span style={{color:'grey'}}>+1 Speed {label} Tier {(rank < 3 ? parseInt(rank) + 1 : rank)} +{50 - rps} rps. <img src={padlock} style={{width:'15px'}} alt="locked" /></span>;
                    tiertwoboostshrt = <span style={{color:'grey'}}><b>+1S</b> {label + " Tier " + (rank < 3 ? parseInt(rank) + 1 : rank)} +{50 - rps} rps. <img src={padlock} style={{width:'15px'}} alt="locked" /></span>
                }
                if (rps >= 100 || prestige >= 3){
                    level = 3;
                    let oceancurrent = (advTrait.includes(ocean) ? "yes" : "no");
                    oceanboost = <span style={{color:(oceancurrent === "yes" ? 'green' : 'red'), textDecorationLine:(oceancurrent === "yes" ? 'unset' : 'line-through')}}>+1 Speed {ocean}  </span>;
                    oceanboostshrt = <span style={{color:(oceancurrent === "yes" ? 'green' : 'red'), textDecorationLine:(oceancurrent === "yes" ? 'unset' : 'line-through')}}><b>+1S</b> {ocean}  </span>;
                }else{
                    let oceancurrent = (advTrait.includes(ocean) ? "yes" : "no");
                    oceanboost = <span style={{color:'grey', textDecorationLine:(oceancurrent === "yes" ? 'unset' : 'line-through')}}>+1 Speed {ocean} +{100 - rps } rps. <img src={padlock} style={{width:'15px'}} alt="locked" /></span>;
                    oceanboostshrt = <span style={{color:'grey', textDecorationLine:(oceancurrent === "yes" ? 'unset' : 'line-through')}}><b>+1S</b> {ocean} +{100 - rps } rps. <img src={padlock} style={{width:'15px'}} alt="locked" /></span>;
                }
                
                if ((rps >= 250 && rank > 0) || (rank > 0 && prestige >= 4)){
                    level = 4;
                    let hemicurrent = ((hemi === "South" && advTrait.substring(0,1) === "S") || (hemi === "North" && advTrait.substring(0,1) === "N") ? 'yes' : 'no');
                    hemiboost = <span style={{color:(hemicurrent === "yes" ? 'green' : 'red'), textDecorationLine:(hemicurrent === "yes" ? 'unset' : 'line-through')}}>+1 Speed {hemi}</span>;
                    hemiboostshrt =<span style={{color:(hemicurrent === "yes" ? 'green' : 'red'), textDecorationLine:(hemicurrent === "yes" ? 'unset' : 'line-through')}}><b>+1S</b> {hemi}</span>;
                }else{
                    if (rank > 0){
                    let hemicurrent = ((hemi === "South" && advTrait.substring(0,1) === "S") || (hemi === "North" && advTrait.substring(0,1) === "N") ? 'yes' : 'no');
                    hemiboost = <span style={{color:'grey', textDecorationLine:(hemicurrent === "yes" ? 'unset' : 'line-through')}}>+1 Speed {hemi} +{250 - rps } rps. <img src={padlock} style={{width:'15px'}} alt="locked" /></span>;
                    hemiboostshrt =<span style={{color:'grey', textDecorationLine:(hemicurrent === "yes" ? 'unset' : 'line-through')}}><b>+1S</b> {hemi} +{250 - rps } rps. <img src={padlock} style={{width:'15px'}} alt="locked" /></span>;
                    }
                }
                if ((rps >= 500 && rank > 1) || (rank > 1 && prestige >= 5)){
                    level = 5;
                    
                        tierfiveboost = "+1 Speed " + (rank === 2 ? seclabel : label);
                        tierfiveboostshrt = "+1S " + (rank === 2 ? seclabel : label);
                    
                }else{
                    if (rank > 1){
                        tierfiveboost = <span style={{color:'grey'}}>+1 Speed {(rank === 2 ? seclabel : label)} +{500 - rps } rps. <img src={padlock} style={{width:'15px'}} alt="locked" /></span>;
                        tierfiveboostshrt = <span style={{color:'grey'}}>+1S {(rank === 2 ? seclabel : label)} +{500 - rps } rps. <img src={padlock} style={{width:'15px'}} alt="locked" /></span>;
                    }
                }
                if (rps >= 750){
                    level = 6;
                }

                raceObj.level = level;
                const levellist = [];
                for (let x = 0; x < level; x++){
                    levellist.push('x');
                }
                raceObj.levelarr = levellist;
                raceObj.legboost = legboost;
                raceObj.legboostshrt = legboostshrt;
                raceObj.baseboost = baseboost;
                raceObj.baseboostshrt = baseboostshrt;
                raceObj.ttboost = tiertwoboost;
                raceObj.ttboostshrt = tiertwoboostshrt;
                raceObj.skinboost = skinboost;
                raceObj.skinboostshrt = skinboostshrt;
                raceObj.oceanboost = oceanboost;
                raceObj.oceanboostshrt = oceanboostshrt;
                raceObj.hemiboost = hemiboost;
                raceObj.hemiboostshrt = hemiboostshrt;
                raceObj.hemicurrent = ((hemiboost === "South" && advTrait.substring(0,1) === "S") || (hemiboost === "North" && advTrait.substring(0,1) === "N") ? 'yes' : 'no');
                raceObj.tfboost = tierfiveboost;
                raceObj.tfboostshrt = tierfiveboostshrt;
            }else{
                
                raceObj.image = collectioninfo.imagepath + newracearr[i] + '.png'
                raceObj.levelarr = [];
                let cr = (selCoachInfo !== undefined && Object.keys(selCoachInfo).length > 0 ? selCoachInfo.Rank : -1);
				cr = parseInt(cr);
				let RP = (selCoachInfo !== undefined ? selCoachInfo.Reef_Points : 0);
                let boosting = (selCoachInfo !== undefined ? selCoachInfo.Label : "");
                let coachPhantSkin = (selCoachInfo !== undefined ? selCoachInfo.Phant_Skin : "");
                let coachPrestige = (selCoachInfo !== undefined ? selCoachInfo.Prestige : "");
            //    console.log(newracearr[i] - 1);
                let selRacerInfo;// = racersAll[newracearr[i] - 1];
            //    console.log(selRacerInfo);
            //    console.log(racersAll);
                for (let r = 0; r < racersAll.length; r++){
                    if (parseInt(racersAll[r].ID) === parseInt(newracearr[i])){
                        selRacerInfo = racersAll[r];
                        break;
                    }
                }
                let coachBoost = (cr < 0 ? 0 : (cr === 0 ? 1 : 2));
                let secBoosting = (selCoachInfo !== undefined ? selCoachInfo.Secondary : "");
                let bNum = 0;
                let weather = weatherInfo.weatherarray.concat(weatherInfo.buffs);
                let totw = weatherInfo.totw;
                switch (cr) {
                    case 0:
                        if (selRacerInfo.Creature.includes(boosting) || selRacerInfo.Tier.includes("Legendary")) {
                            bNum = coachBoost;
                            if ((RP >= 50 || coachPrestige >=2) && selRacerInfo.Tier.includes("1")) {
                                bNum += 1;

                            }
                        }
                        break;

                    case 1:
                        
                    if (selRacerInfo.Creature.includes(boosting) || selRacerInfo.Tier.includes("Legendary")) {
                        bNum = coachBoost;
                        if ((RP >= 50 || coachPrestige >=2) && selRacerInfo.Tier.includes("2")) {
                            bNum += 1;
                        }
                    }
                    break;

                    case 2:
                        if (selRacerInfo.Tier.includes(boosting) || selRacerInfo.Tier.includes("Legendary")) {
                            bNum = coachBoost;
                            if (newracearr[i] === 66){
                          //  console.log('pre boosting');
                          //      console.log(bNum);
                            }
                            if ((RP >= 50 || coachPrestige >=2) && selRacerInfo.Tier.includes("3")) {
                                bNum += 1;
                                if (newracearr[i] === 66){
                           //         console.log('boosting');
                           //             console.log(bNum);
                                    }
                            }
                        }
                    break;
                    case 3:
                        if (selRacerInfo.Tier.includes(boosting)) {
                            bNum = coachBoost;
                            if ((RP >= 50 || coachPrestige >=2) && selRacerInfo.Tier.includes("3")) {
                                bNum += 1;
                            }
                        }
                        if (selRacerInfo.Tier.includes("Mythic") || selRacerInfo.Tier.includes("Legendary")) {
                            bNum = 2;
                        }
                    break;
                    default:
                    break;
                }
               
                if (RP >= 100 || coachPrestige >= 3){
                    if(advTrait.includes(selCoachInfo.Ocean) === true && selRacerInfo.Advantage.includes(selCoachInfo.Ocean)) {
                        bNum += 1;
                    }else if(advTrait.includes(selCoachInfo.Ocean) && selRacerInfo.Advantage === "World Ocean"){
                        bNum += 1;
                    }else if (advTrait.includes(selCoachInfo.Ocean) && advTrait.substring(0,1) === "N" && selRacerInfo.Advantage === "North") {
                        bNum += 1;
                    }else if (advTrait.includes(selCoachInfo.Ocean) && advTrait.substring(0,1) === "S" && selRacerInfo.Advantage === "South"){
                        bNum += 1;

                    }		
                }

               
                if ((RP >= 250 || coachPrestige >= 4) && cr > 0){
                    if(advTrait.substring(0,2) === "N " && selCoachInfo.Hemisphere === "North")
                {
                    if (selRacerInfo.Advantage === "World Ocean" || selRacerInfo.Advantage === "North" || advTrait.includes(selRacerInfo.Advantage)) {
                        bNum += 1;
                    }
                        
                    } else if (advTrait.substring(0,2) === "S " && selCoachInfo.Hemisphere === "South") {
                        if (selRacerInfo.Advantage === "World Ocean" || selRacerInfo.Advantage === "South" || advTrait.includes(selRacerInfo.Advantage)) {
                            bNum += 1;
                        }
                    }		
                }
                
                if ((RP >= 500 || coachPrestige >= 5) && cr > 1){
                    if (cr === 2){
                        if (selRacerInfo.Creature.includes(secBoosting)){
                            bNum += 1;
                        }
                    }else {
                        if (selRacerInfo.Tier.includes(boosting)) {
                            bNum += 1;
                        }
                    }
                }


            if (RP >= 10 && ( selRacerInfo.Phant_Skin === coachPhantSkin || coachPhantSkin === "Gold")){
                bNum += 1;
            }

            
            let istotw = 'no';
            let wBoostB = 0;
            let wBoostBHi = 0;
            let wBoostBLo = 0;
          //  for(let x = 0; x < weather.length; x++){
          //      for (let y = 0; y < selRacerInfo.length; y++){
          //          if (temp["attributes"][y].trait_type === weather[x].trait && temp["attributes"][y].value === weather[x].value && weather[x].bonustype === "speed"){
          //              wBoostB += parseInt(weather[x].bonus);
           //         }
           //     }
                
           // }
 
            let aBoost = 0;
            if (selRacerInfo.Tier.includes("1")){
                aBoost = 0;
            } else if (selRacerInfo.Tier.includes("2")){
                aBoost = 1;
            } else if (selRacerInfo.Tier.includes("3") || selRacerInfo.Tier === "Custom"){
                aBoost = 2;
            } else {
                aBoost = 3;
            }
            
            let advBoost = 0;
            if (advTrait.includes(selRacerInfo.Advantage) === true || selRacerInfo.Advantage === "World Ocean") {
                advBoost = 2;
            }
            if (advTrait.slice(0, 1) === "N" && selRacerInfo.Advantage === "North") {
                advBoost = 2;
            }
            if (advTrait.slice(0, 1) === "S" && selRacerInfo.Advantage === "South") {
                advBoost = 2;
            }
            let wBoostA = 0;
            let wBoostAHi = 0;
            let wBoostALo = 0;
            let wBoostE = 0;
            let wBoostEHi = 0;
            let wBoostELo = 0;

            for(let x = 0; x < weather.length; x++){
                //      for (let y = 0; y < selRacerInfo.length; y++){
                //          if (temp["attributes"][y].trait_type === weather[x].trait && temp["attributes"][y].value === weather[x].value && weather[x].bonustype === "accel"){
                //              wBoostB += parseInt(weather[x].bonus);
                 //         }
                 //     }
                 for (const [key, value] of Object.entries(selRacerInfo)) {
                    
                    if (key === weather[x].trait.replace(" ", "_") && value === weather[x].value && weather[x].bonustype === "speed"){
                        wBoostB += parseInt(weather[x].bonus);
                        if (parseInt(weather[x].bonus) > 0 ) {
                            wBoostBHi += parseInt(weather[x].bonus);
                        }else{
                            wBoostBLo += parseInt(weather[x].bonus);
                        }
                        break;
                    }
                    if (key === totw.trait.replace(" ", "_") && value === totw.value ){
                        istotw = 'yes';
                    }
                }

                      for (const [key, value] of Object.entries(selRacerInfo)) {
                          if (key === weather[x].trait.replace(" ", "_") && value === weather[x].value && weather[x].bonustype === "accel"){
                              wBoostA += parseInt(weather[x].bonus);
                              if (parseInt(weather[x].bonus) > 0 ) {
                                wBoostAHi += parseInt(weather[x].bonus);
                            }else{
                                wBoostALo += parseInt(weather[x].bonus);
                            }
                          }
                      }

                      for (const [key, value] of Object.entries(selRacerInfo)) {
                        if (key === weather[x].trait.replace(" ", "_") && value === weather[x].value && weather[x].bonustype === "endur"){
                            wBoostE += parseInt(weather[x].bonus);
                            if (parseInt(weather[x].bonus) > 0 ) {
                                wBoostEHi += parseInt(weather[x].bonus);
                            }else{
                                wBoostELo += parseInt(weather[x].bonus);
                            }
                        }
                    }
                  }
                  let rolename = "";
                  let roleboost = 0;
                for (let x = 1; x < 4; x++){
                  
                  if (anch[x].id === parseInt(selRacerInfo.ID) && anch[x].contract === selRacerInfo.Contract) {
                    rolename= "Anchor";
                    roleboost = 4;
                } else if (vc[x].id === parseInt(selRacerInfo.ID)  && vc[x].contract === selRacerInfo.Contract) {
                    rolename = "Assistant Captain";
                    roleboost = 1;
                } else if (equip[x].id === parseInt(selRacerInfo.ID)  && equip[x].contract === selRacerInfo.Contract) {
                    rolename = "Equipment Manager";
                    roleboost = -2;
                } else if (bench[x].id === parseInt(selRacerInfo.ID) && bench[x].contract === selRacerInfo.Contract) {
                    rolename = "Bench Warmer";
                    roleboost = -1;
                } else if (capt[x].id === parseInt(selRacerInfo.ID) && capt[x].contract === selRacerInfo.Contract) {
                    rolename = "Captain";
                    roleboost = 3;
                }
            }


                let tierTypes = getRaceTypes('regular');
                raceObj.speedBase = speedBase;
                raceObj.accelBase = accelBase;
                raceObj.endurBase = endurBase;
                raceObj.bNum = bNum;
                raceObj.wBoostA = wBoostA;
                raceObj.wBoostAHi = wBoostAHi;
                raceObj.wBoostALo = wBoostALo;
                raceObj.wBoostB = wBoostB;
                raceObj.wBoostBHi = wBoostBHi;
                raceObj.wBoostBLo = wBoostBLo;
                raceObj.wBoostE = wBoostE;
                raceObj.wBoostEHi = wBoostEHi;
                raceObj.wBoostELo = wBoostELo;
                raceObj.advBoost = advBoost;
                raceObj.aBoost = aBoost;
                raceObj.roleBoost = roleboost;
                raceObj.roleName = rolename;
                raceObj.creatureName = selRacerInfo.Creature;
                raceObj.creatureAccel = selRacerInfo.CreatureAccel;
                raceObj.creatureEndur = selRacerInfo.CreatureEndur;
                raceObj.advantage = selRacerInfo.Advantage;
                raceObj.speedTotal = speedBase + advBoost;
                raceObj.accelTotal = accelBase + aBoost + parseInt(selRacerInfo.CreatureAccel);
                raceObj.endurTotal = endurBase + parseInt(selRacerInfo.CreatureEndur);
                raceObj.tier = selRacerInfo.Tier;
                raceObj.tiernum = tierTypes.indexOf(selRacerInfo.Tier);
                raceObj.isTotw = istotw;
                raceObj.contract = nftcontract;
            }
            racers.push(raceObj);
            raceObj = {};
        }
        return [racers, manageSty];
    }

     const getStoredHydro = async( _account) => {
        const stakeContract = await getStakingContractOtherRO();

        let hydro = await stakeContract.checkHydrolyte( _account);

        return hydro;
    }

 /*   const getCustomRacers = async(walletAddress, nftcontract) => {
        let racearray = await getNFTS(walletAddress, nftcontract);
        let racers = [];
        let raceObj = {};
        let newracearr = racearray.map(x => parseInt(x));
        newracearr.sort(function(a, b){return a - b});
        for (let i = 0; i < newracearr.length; i++){
            raceObj.collection = 'EOR';
            raceObj.id = newracearr[i];
            raceObj.image = 'https://oceanracingleague.com/collections/customs/images/' + newracearr[i] + '.png'
            racers.push(raceObj);
            raceObj = {};
        }
        return racers;
    }

    const getCoaches = async(walletAddress, nftcontract) => {
        let racearray = await getNFTS(walletAddress, nftcontract);
        let racers = [];
        let raceObj = {};
        let newracearr = racearray.map(x => parseInt(x));
        newracearr.sort(function(a, b){return a - b});
        for (let i = 0; i < newracearr.length; i++){
            raceObj.collection = 'EOR';
            raceObj.id = newracearr[i];
            raceObj.image = 'https://oceanracingleague.com/collections/customs/images/' + newracearr[i] + '.png'
            racers.push(raceObj);
            raceObj = {};
        }
        return racers;
    }
*/
    const getAccountName = async(walletAddress) => {
        const acccontract = await getAccountContractRO();
        let accname = await acccontract.getAllNames(walletAddress);

        return accname;
    }

    const getTransferFaves = async(walletAddress) => {
        const acccontract = await getAccountContractRO();
        let accname = await acccontract.getTransferFavorites(walletAddress);

        return accname;
    }

    const checkAccountName = async(accountname) => {
        const acccontract = await getAccountContractRO();
        let accname = await acccontract.nameTaken(accountname);

        return accname;
    }

    const checkTransferStatus = async(walletAddress) => {
        const acccontract = await getAccountContractRO();
        let accname = await acccontract.getTransferStatus(walletAddress);

        return accname;
    }

    const updateName = async(walletaddress, accountname, league) => {
        const acccontract = await getAccContractForCalls();
        let resp = '';
        try{
        let updateResults = await acccontract.nameUpdate(accountname, walletaddress, league);
        const updateResultsResp = await updateResults.wait();
        resp = updateResultsResp;
        }catch (err) {
            if (err.code === "ACTION_REJECTED"){
                resp = undefined;
            }else{
                    console.log(acccontract.interface.parseError(err.data));
                    let errdata = acccontract.interface.parseError(err.data).name;
                    resp = errdata;
             //   resp = ex;
            }
            
        }
    
        return resp;
    }

    const updateShortName = async(walletaddress, shortname, league) => {
        const acccontract = await getAccContractForCalls();
        let resp = '';
        try{
        let updateResults = await acccontract.shortNameUpdate(shortname, walletaddress, league);
        const updateResultsResp = await updateResults.wait();
        resp = updateResultsResp;
        }catch (ex) {
            if (ex.code === "ACTION_REJECTED"){
                resp = undefined;
            }else{
                resp = ex;
            }
            
        }
    
        return resp;
    }

    const updateAllowTransfers = async(allowStatus) => {
        const acccontract = await getAccContractForCalls();
        let resp = '';
        try{
        let updateResults = await acccontract.updateTransferStatus(allowStatus);
        const updateResultsResp = await updateResults.wait();
        resp = updateResultsResp;
        }catch (ex) {
            if (ex.code === "ACTION_REJECTED"){
                resp = undefined;
            }else{
                resp = ex;
            }
            
        }
    
        return resp;
    }

    const updateTransferFavorite = async(walletaddress, transferwallet, favstatus) => {
        const acccontract = await getAccContractForCalls();
        let resp = '';
        try{
        let updateResults = await acccontract.updateTransferFav(transferwallet, favstatus);
        const updateResultsResp = await updateResults.wait();
        resp = updateResultsResp;
        }catch (ex) {
            if (ex.code === "ACTION_REJECTED"){
                resp = undefined;
            }else{
                resp = ex;
            }
            
        }
    
        return resp;
    }

    const transferNfts = async(to, ids, contracts) => {
        const acccontract = await getAccContractForCalls();
        let resp = '';
        try{
        let updateResults = await acccontract.transferTo(to, ids, contracts);
        const updateResultsResp = await updateResults.wait();
        resp = updateResultsResp;
        console.log(resp);
        }catch (ex) {
            if (ex.code === "ACTION_REJECTED"){
                resp = undefined;
            }else{
                resp = ex;
            }
            
        }
    
        return resp;
    }

    const transferOneRacer = async(walletAddress, to, id) => {
        const nftcontract = await getEORContractForCalls();
        let updateTransferStatus = await nftcontract.safeTransferFrom(walletAddress, to, id);

        let resp = '';
        try{
        const updateResultsResp = await updateTransferStatus.wait();
        resp = updateResultsResp;
        }catch (ex) {
            if (ex.code === "ACTION_REJECTED"){
                resp = undefined;
            }else{
                resp = ex;
            }
            
        }

        return resp;
    }

    const transferOneCoach = async(walletAddress, to, id) => {
        const nftcontract = await getCoachContractForCalls();
        let updateTransferStatus = await nftcontract.safeTransferFrom(walletAddress, to, id);

        let resp = '';
        try{
        const updateResultsResp = await updateTransferStatus.wait();
        resp = updateResultsResp;
        }catch (ex) {
            if (ex.code === "ACTION_REJECTED"){
                resp = undefined;
            }else{
                resp = ex;
            }
            
        }

        return resp;
    }

/*

const createRaces = async (maticInWei, pearls, opponents, nfts, nftscontracts, nftowners, racecnt, openrace, nftracer, nftracercoll) => {
    const racecontract = await getSRNegotsContractForCalls();
  
    let resp = '';
    try{
    let raceResults = await racecontract.callStatic.raceSetup(ethers.utils.parseEther(maticInWei), pearls,  opponents, nfts, nftscontracts, nftowners, racecnt, openrace, nftracer, nftracercoll);
    raceResults = await racecontract.raceSetup(ethers.utils.parseEther(maticInWei), pearls,  opponents, nfts, nftscontracts, nftowners, racecnt, openrace, nftracer, nftracercoll);
    const raceResultsResp = await raceResults.wait();
    resp = raceResultsResp;
    }catch (err) {
        if (err.code === 'CALL_EXCEPTION'){
            resp = err.errorName;
            console.log(err);
        }
    }

    return resp;
}

const negotiateRace = async (maticInWei, pearls, currracenum, nfts, nftcontracts, nftowners) => {
    const racecontract = await getSROffersContractForCalls();
    console.log(pearls);
    let resp = '';
    try {
    let negotsResults = await racecontract.callStatic.updateOffer(ethers.utils.parseEther(maticInWei), pearls,currracenum, nfts, nftcontracts,nftowners);
    negotsResults = await racecontract.updateOffer(ethers.utils.parseEther(maticInWei), pearls,currracenum, nfts, nftcontracts,nftowners);
    const negResultsResp = negotsResults.wait();
    resp = negResultsResp;
    console.log(resp);

    }catch (err){
        resp = err.errorName;
    }

    return resp;
}

const getNegotiation = async(currracenum) => {
    const racecontract = await getReefRaceOffersRO();
    let resp = ''
    try {
        let negots = await racecontract.getNegots(currracenum);
        resp = negots;
    }catch (err){
        resp = err.errorName;
    }

    return resp;
}

const cancelRaces = async(racenum) => {
    const racecontract = await getSRNegotsContractForCalls();
    let resp = '';
    try{
        let cancelResults = await racecontract.callStatic.cancelRace(racenum);

        cancelResults = await racecontract.cancelRace(racenum);
        const cancelResultsResp = await cancelResults.wait();
        resp = cancelResultsResp;
    }catch(err){
        resp = err;
    }
    
    return resp;
}

const acceptRace = async(racenum, nftid, nftcontract, maticInWei) => {
    const racecontract = await getSRNegotsContractForCalls();
    let matic = ethers.utils.parseEther(maticInWei);
    let resp = '';
    try{
        let gasest = await racecontract.estimateGas.acceptRace(racenum, nftid, nftcontract,{value: matic});
        const incGasLimit = Math.floor(parseInt(gasest) * 1.1);
        console.log(incGasLimit);
        let acceptResults = await racecontract.callStatic.acceptRace(racenum, nftid, nftcontract,{value: matic, gasLimit: incGasLimit});
        acceptResults = await racecontract.acceptRace(racenum, nftid, nftcontract,{value: matic, gasLimit: incGasLimit});
        const acceptResultsResp = await acceptResults.wait();
        resp = acceptResultsResp;
    }catch(err){
        resp = err;
    }
    
    return resp;
}

const getRaceListing = async(walletAddress) => {
    const racecontract = await getReefRaceRacesRO();//await getSRContractForCalls();
    const raceListingRes = await racecontract.getCompletedRaceInfo(walletAddress);
    let openrace = [];

    for (let race in raceListingRes){
        if (parseInt(raceListingRes[race].raceinfo.raceid) !== 0){
        let singleitem = {};
        let nftbetsupdated = [];
        let singlebet = {};
        singleitem.matic = ethers.utils.formatEther(raceListingRes[race].raceinfo.matic);
        singleitem.pearls = parseInt(raceListingRes[race].raceinfo.pearls);
        singleitem.raceid = parseInt(raceListingRes[race].raceinfo.raceid);
        singleitem.racers = raceListingRes[race].raceinfo.racers;
        singleitem.nfts = parseInt(raceListingRes[race].raceinfo.nfts);
        singleitem.winner = raceListingRes[race].raceinfo.winner;
        singleitem.challenger = raceListingRes[race].raceinfo.challenger;
        singleitem.lastupdated =  raceListingRes[race].raceinfo.lastupdated;
        singleitem.racecnt =  raceListingRes[race].raceinfo.racecnt;
        singleitem.negotid =  parseInt(raceListingRes[race].raceinfo.negotid);
        singleitem.racenums =  [];
        const newbets = raceListingRes[race].nftbets.slice(0,parseInt(raceListingRes[race].raceinfo.nfts));
        for(let i = 0; i < newbets.length; i ++ ){
            const coll = getCollectionByAddress(newbets[i].nftContract);
            singlebet.id = parseInt(newbets[i].id);
            singlebet.wallet = newbets[i].wallet;
            singlebet.nftContract = newbets[i].nftContract;
            singlebet.imgpath = coll.imagepath + parseInt(newbets[i].id).toString() + '.png';;
            singlebet.collection = coll.collection;
            nftbetsupdated.push(singlebet);
            singlebet = {};
        }
        singleitem.nftbets = nftbetsupdated;
        openrace.push(singleitem);
    }
     }

    return openrace;
}


const getOpenListing = async(walletAddress) => {
    const racecontract = await getReefRaceNegotsRO();//await getSRContractForCalls();
    const raceListingRes = await racecontract.getOpenRaceInfo(walletAddress);
    let openrace = [];

    for (let race in raceListingRes){
        if (parseInt(raceListingRes[race].neginf.negid) !== 0){
        let singleitem = {};
        let nftbetsupdated = [];
        let singleoffer = {};
        let nftbet = {};
        let nftbets = [];
        let currRacers = [];
        let curRacer = {};
        singleitem.raceid = parseInt(raceListingRes[race].neginf.negid);
        singleitem.racers = raceListingRes[race].neginf.racers;
       // singleitem.nfts = parseInt(raceListingRes[race].neginf.nfts);
        singleitem.canceled = raceListingRes[race].neginf.canceled;
        singleitem.openrace = raceListingRes[race].neginf.openrace;
        singleitem.racecnt = raceListingRes[race].neginf.racecnt;
        singleitem.challenger = raceListingRes[race].neginf.challenger;
        singleitem.completed = raceListingRes[race].neginf.completed;
        singleitem.lastupdated = raceListingRes[race].neginf.lastupdated;
        const newoffers = await getNegotiation(parseInt(raceListingRes[race].neginf.negid));//raceListingRes[race].curnegs;
        for(let i = 0; i < newoffers.length; i++ ){
            
            singleoffer.matic = ethers.utils.formatEther(newoffers[i].matic);
            singleoffer.pearls = parseInt(newoffers[i].pearls);
            singleoffer.racer = newoffers[i].racer;
            singleoffer.nfts = parseInt(newoffers[i].nfts);

            for(let x = 0; x < newoffers[i].nfts; x++){
                const coll = getCollectionByAddress(newoffers[i].nftContract[x]);
                nftbet.id = parseInt(newoffers[i].id[x]);
                nftbet.nftContract = newoffers[i].nftContract[x];
                nftbet.imgpath = coll.imagepath + parseInt(newoffers[i].id[x]).toString() + '.png';
                nftbet.wallet = newoffers[i].wallet[x];
                nftbet.collection = coll.collection;
                nftbets.push(nftbet);
                nftbet = {};
            }
            singleoffer.nftbets = nftbets;
            nftbets = [];
            nftbetsupdated.push(singleoffer);
            singleoffer = {};
        }
        singleitem.offers = nftbetsupdated;
        const currrac = raceListingRes[race].curracers;
        for (let x = 0; x < currrac.length; x++ ){
            curRacer.id = parseInt(currrac[x].id);
            curRacer.nftContract = currrac[x].nftContract;
            curRacer.accepted = currrac[x].raceAccepted;
            curRacer.wallet = raceListingRes[race].neginf.racers[x];
            let displaycoll = getCollectionByAddress(currrac[x].nftContract);
            curRacer.collection = displaycoll.collection;
            curRacer.tier = getTierByCollection(currrac[x].nftContract, parseInt(currrac[x].id));
            currRacers.push(curRacer);
            curRacer = {};
        }
        singleitem.racersStatus = currRacers;
        openrace.push(singleitem);
    }

    
     }
    return openrace;
}

*/
const getTierByCollection = (contract, nftid) => {
    let tierstr = '';

    for (let x = 0; x < tiers.length; x++){

        
        if (tiers[x].address.toLowerCase() === contract.toLowerCase()){
            if (tiers[x].tierone.includes(parseInt(nftid))){
                tierstr = 'Tier 1';
            }else if (tiers[x].tiertwo.includes(parseInt(nftid))){
                tierstr = 'Tier 2';
            }else if (tiers[x].tierthree.includes(parseInt(nftid))){
                tierstr = 'Tier 3';
            }else if (tiers[x].legendary.includes(parseInt(nftid))){
                tierstr = 'Legendary';
            }
            break;
            
        }
        
    }

    return tierstr;
}

const getEORMintInfo = async(walletAddress) => {
    let toneMinted = 0;
    let excMinted = 0;
    let tonePrice = 0;
    let excPrice = 0;
    let totTone = 0;
    let totExc = 0;
    let toneExcPrice = 0;
    
    const prxcontract = await getProxyContractRO();
    toneMinted = await prxcontract.minted();
    excMinted = await prxcontract.excluMinted();
    tonePrice = await prxcontract.tonePrice();
    excPrice = await prxcontract.excluPrice();
    toneExcPrice = await prxcontract.toneExcluPrice();
    const mintOpts = await prxcontract.mintOptions(walletAddress);
    totTone = await prxcontract.supply();
    totExc = await prxcontract.excluSupply();

   

    let mintedObj = {};
    mintedObj.tone = toneMinted;
    mintedObj.exc = excMinted;
    mintedObj.toneprice = parseInt(tonePrice);
    mintedObj.excprice = parseInt(excPrice);
    mintedObj.toneexcprice = parseInt(toneExcPrice);
    mintedObj.maxexclu = mintOpts.exclusive;
    mintedObj.excdrops = mintOpts.excdrops;
    mintedObj.tonedrops = mintOpts.tonedrops;
    mintedObj.toneexcdrops = mintOpts.exclusivetone;
    mintedObj.totaltone = totTone;
    mintedObj.totExc = totExc;

    return mintedObj;
}

const getCoachMintInfo = async(walletAddress) => {
    let minted = 0;
    let cost = 0;
    let freemints = 0;
    let totalmints = 0;
    const coachcontract = await getCoachContractRO();
    minted = await coachcontract.totalSupply();
    cost = await coachcontract.getCost();
    freemints = await coachcontract.freeMints(walletAddress);
    totalmints = await coachcontract.getMaxSupply();
    
    let mintedObj = {};
    mintedObj.coachmint = minted;
    mintedObj.coachcost = parseInt(cost);
    mintedObj.freemints = freemints;
    mintedObj.totalmints = totalmints;


    return mintedObj;
}

const mintEORNFTS = async(walletAddress, qty, minttype, cost) => {
    const eorcontract = await getProxyContractForCalls();
    let results;
    let resp;
    try{
     //   results = await eorcontract.callStatic.mintByProxy(walletAddress, qty, minttype, {value:ethers.parseEther(cost).toString()});
        results = await eorcontract.mintByProxy(walletAddress, qty, minttype, {value:ethers.parseEther(cost.toString())});
        let mintresults = results.wait();
        resp = mintresults;
    }catch(ex){
        if (ex.code === "ACTION_REJECTED"){
            resp = undefined;
        }else{
        //    resp = ex;
            let tempresp = eorcontract.interface.parseError(ex.data);//ex;
            resp = tempresp.args[0];
        }
    }

    return resp;
}

const mintCoachNFTS = async(walletAddress, qty, cost) => {
    const coachcontract = await getCoachContractForCalls();
    let results;
    let resp;
    try{
     //   results = await eorcontract.callStatic.mintByProxy(walletAddress, qty, minttype, {value:ethers.parseEther(cost).toString()});
        results = await coachcontract.mint(qty, walletAddress,  {value:ethers.parseEther(cost.toString())});
        let mintresults = results.wait();
        resp = mintresults;
    }catch(ex){
        if (ex.code === "ACTION_REJECTED"){
            resp = undefined;
        }else{
            //resp = ex;
            resp = coachcontract.interface.parseError(ex.data).name;//ex;
        }
    }

    return resp;
}


const checkPearlApproval = async(walletAddress) => {
    const pearlcontract = await getPearlContractRO();
    const pearlapproval = await pearlcontract.allowance(walletAddress, stakingcontractadd);
    return pearlapproval;
}

const setPearlBalance = async(walletaddress) => {
    const pearlcontract = await getPRContractForCalls();
    let resp;
    try{
        const pearlbalance = await pearlcontract.approve(stakingcontractadd, 1000000);
        const pearlBalResp = await pearlbalance.wait();
        resp = pearlBalResp;
    }catch(err){
        resp = err;
    }
    
    return resp;
}


const checkNFTOwner = async(collectioncontract, nftid, walletaddress) => {
    const nftcontract = await getNFTCollectionRO(collectioncontract);
    let isowner = false;

    const nftowner = await nftcontract.ownerOf(nftid);
    if (nftowner === walletaddress){
        isowner = true;
    }
    return isowner;
}






const getNFTSByOwner = async(walletAddress, ourcollects) => {

         let onenft = {};
          let result = [];
    for await (const nft of alchemy.nft.getNftsForOwnerIterator(walletAddress)) {
        if (ourcollects.find(i => i.addrs.toUpperCase() === nft.contract.address.toUpperCase())){
            if (nft.tokenId !== '0'){
            result.push(onenft);
            onenft = {};
            }
        }
      }

      return result;

}

const setLeagueCoach = async(league, coachid) => {
    let coachSetResp;
    const stakeContract = await getStakingContractOtherForCalls();
    try{
    
    const coachSet = await stakeContract.setCoach(coachid, league);
    coachSetResp = await coachSet.wait();
}catch(ex){
    console.log(ex);
    if (ex.code === "ACTION_REJECTED"){
        coachSetResp = undefined;
    }else{
        console.log(stakeContract.interface.parseError(ex.data));
        coachSetResp = stakeContract.interface.parseError(ex.data).name;//ex;
        
    }
    
}

    return coachSetResp;
}

const setLeagueManagement = async(league, manageid) => {
    let manSetResp;
    const stakeContract = await getStakingContractOtherForCalls();
    try{
    console.log(league);
    console.log(manageid);
    const manSet = await stakeContract.setManagmentStyle(league, manageid);
    manSetResp = await manSet.wait();
}catch(ex){
    console.log(ex);
    if (ex.code === "ACTION_REJECTED"){
        manSetResp = undefined;
    }else{
        console.log(stakeContract.interface.parseError(ex.data));
        manSetResp = stakeContract.interface.parseError(ex.data).name;//ex;
        
    }
    
}

    return manSetResp;
}


const stakeRacers = async(selectedRacers, currentWeek, currentAccount, league) => {

let list = [];
let contractList = [];
let evList = [];
let maticPrices = [];
let pearlPrices = [];
let pearlTotal = 0;
let maticTotal = 0;
const leaguenum = parseInt(league);  
const stakeContractRO = await getStakingContractRO();

for (let i = 0; i < selectedRacers.length; i++) {
//	if (selected.sel[i]) {
if (maticPrices[selectedRacers[i].raceid] === undefined){
let _rules = await stakeContractRO.rulesByRace(leaguenum, parseInt(currentWeek), selectedRacers[i].raceid);
let nftPrice = parseInt(_rules.matPrice);
nftPrice = ( nftPrice / 1000000000000000000 );
let pearlPrice = parseInt(_rules.prlPrice);
pearlPrice = (pearlPrice / 100000000000000000)
maticPrices[selectedRacers[i].raceid] = nftPrice;
pearlPrices[selectedRacers[i].raceid] = pearlPrice;
}
maticTotal += maticPrices[selectedRacers[i].raceid];
pearlTotal += pearlPrices[selectedRacers[i].raceid];
list.push(selectedRacers[i].id);
contractList.push(selectedRacers[i].contract);
evList.push(selectedRacers[i].raceid);
}

    maticTotal = maticTotal.toFixed(2);
    maticTotal = maticTotal.toString();
    const pearlContractRO = await getPearlContractRO();
    
        let pearlsAllowed = await pearlContractRO.allowance(currentAccount, stakingcontractadd);
        


    pearlsAllowed = parseInt(ethers.formatEther(pearlsAllowed)) ;
   
    const pearlContract = await getPRContractForCalls();

    const stakeContract = await getStakingContractForCalls();

    let tx;
    let signUpResp;
        try{
            if (pearlsAllowed >= pearlTotal) {
            //    console.log(maticTotal);
            //    console.log(parseInt(ethers.parseEther(maticTotal)))
                tx = await stakeContract.signUp(list, contractList, evList, leaguenum, { value: ethers.parseEther(maticTotal)});
                
            } else {
            
                let tmz = await pearlContract.approve(stakingcontractadd, ethers.parseEther((1000000).toString()));
                await tmz.wait();
            
                tx = await stakeContract.signUp(list, contractList, evList, leaguenum, { value: ethers.parseEther(maticTotal)});
                
            }
        signUpResp = await tx.wait();
        }catch(ex){
            
            if (ex.code === "ACTION_REJECTED"){
                signUpResp = undefined;
            }else{
             //   console.log(stakeContract.interface.parseError(ex.data));
                signUpResp = stakeContract.interface.parseError(ex.data).name;//ex;
            }
            
        }
       
        
        console.log(signUpResp);
        return signUpResp;

}

const unstakeRacers = async(selectedRacers) => {

    let list = [];
    let contracts = [];

    const stakeContract = await getStakingContractForCalls();

    for (let x = 0; x < selectedRacers.length; x++){
        list.push(selectedRacers[x].id);
        contracts.push(selectedRacers[x].contract);
    }
    let unstakeResp;
    try{
        let unStakeResult = await stakeContract.returnTokens(list, contracts);
        unstakeResp = await unStakeResult.wait();
    }catch(ex){
        if (ex.code === "ACTION_REJECTED"){
            unstakeResp = undefined;
        }else{
            console.log(stakeContract.interface.parseError(ex.data));
            unstakeResp = stakeContract.interface.parseError(ex.data).name;//ex;
            
        }
    }
    

    return unstakeResp;


}

const moveRacers = async(selectedRacers, event) => { 
    let list = [];
    let contracts = [];
    let moveEvent = event;
    let events = [];

    const stakeContract = await getStakingContractForCalls();

    if (moveEvent !== "0" && moveEvent !== "1" && moveEvent !== "21"){
        let racetype = getRaceTypes();
        for (let x = 0; x < racetype.length; x++){
            if (racetype[x] === moveEvent){
                moveEvent = x;
            }
        }

    }

    for (let x = 0; x < selectedRacers.length; x++){
        list.push(selectedRacers[x].id);
        contracts.push(selectedRacers[x].contract);
        events.push(moveEvent);
    }
    
    let moveResp;
    try{
        let moveResult = await stakeContract.changeEvent(list, contracts, events);
        moveResp = await moveResult.wait();
    }catch(ex){
        if (ex.code === "ACTION_REJECTED"){
            moveResp = undefined;
        }else{
            let returnError =  stakeContract.interface.parseError(ex.data);
            console.log(returnError);
            moveResp = returnError.fragment.name;
        }
    }
    
    return moveResp;
}

const assignHydro = async(racers, contracts, hydro, league) => { 


    const stakeContract = await getStakingContractForCalls();

    console.log(racers);
    console.log(contracts);
    console.log(hydro);
    
    let hydroResp;
    try{
        let moveResult = await stakeContract.setHydrolyte(racers, contracts, hydro, league);
        hydroResp = await moveResult.wait();
    }catch(ex){
        if (ex.code === "ACTION_REJECTED"){
            hydroResp = undefined;
        }else{
            let returnError =  stakeContract.interface.parseError(ex.data);
            console.log(returnError);
            hydroResp = returnError.fragment.name;
        }
    }
    
    return hydroResp;
}



const getNFTSByContractandOwner = async(walletAddress, collectionid) => {

    let onenft = {};
     let result = [];
for await (const nft of alchemy.nft.getNftsForOwnerIterator(walletAddress, {contractAddresses: collectionid, omitMetadata : true})) {

       onenft = nft;
       result.push(onenft.tokenId);
       onenft = {};
 
 }

 return result;

}

const checkAddress = async(address) => {
    const isValid = ethers.isAddress(address);

    return isValid;
}

const checkSignature = async(address) => {
            const _TOSro = await getTOSContractRO()
				let sig = await _TOSro.checkSignature(address);

                return sig;
}

const setSignature = async(address) => {
    const _TOS = await getTOSContractForCalls();
    let sigResp;
    try{
        let sig = await _TOS.signHere();
        sigResp = await sig.wait();
    }catch(ex){
        if (ex.code === "ACTION_REJECTED"){
            sigResp = undefined;
        }else{
            sigResp = ex;
        }
    }
        return sigResp;
}



const getRaceTypes = (racetype) => {
    let raceTypes = [];
    
    
    if (racetype === "regatta") {
        raceTypes = ["Regatta","Alternate"];
            }else if(racetype === "sharkweek") {
        raceTypes = ["Tier 1 Sharks and Whalesharks","Tier 2 Sharks and Whalesharks","Tier 3 Sharks and Whalesharks","Minor League Sharks and Whalesharks"];

    }else{
        raceTypes =["Free For All",
"Hi - Lo",
"Cruiser 1",
"Cruiser 2",
"Cruiser 3",
"Arctic 1",
"Arctic 2",
"Arctic 3",
"Turbo 1",
"Turbo 2",
"Turbo 3",
"XL 1",
"XL 2",
"XL 3",
"Predator 1",
"Predator 2",
"Predator 3",
"Mythic 1",
"Mythic 2",
"Mythic 3",
"Legendary",
"Custom",
"Trait of the Week",
"",
"",
"",
"",
"",
"",
"",
"Playoffs",
"Invitational"
];
    }
return raceTypes;

}

const getManagementStyles = () => {
    let manageStyles = [];
    let singleStyle = {};
    singleStyle.name = "Sprint";
    singleStyle.bonustype = "accel";
    singleStyle.bonus = "1";
    singleStyle.totalbonus = accelBase;
    singleStyle.calctype = "multi";
    singleStyle.contract = "2";
    singleStyle.desc = "Total Accel 2"
    manageStyles.push(singleStyle);
    singleStyle ={};
    singleStyle.name = "Marathon";
    singleStyle.bonustype = "endur";
    singleStyle.bonus = "2";
    singleStyle.totalbonus = endurBase;
    singleStyle.calctype = "multi";
    singleStyle.contract = "3";
    singleStyle.desc = "Total Endur 3"
    manageStyles.push(singleStyle);
    singleStyle ={};
    singleStyle.name = "Competitive";
    singleStyle.bonustype = "speed";
    singleStyle.bonus = "2";
    singleStyle.totalbonus = 2; 
    singleStyle.calctype = "plus";
    singleStyle.contract = "1";
    singleStyle.desc = "Speed +2"
    manageStyles.push(singleStyle);
    return manageStyles;
}

const getManagementStyleBonuses = (managestyle, total,weather, boosttype) => {
    let tempspeed = 0;
    let tempaccel = parseInt(total) + parseInt(weather);
    let tempendur = parseInt(total) + parseInt(weather);
    let boostreturn = 0;
    let mangementStyleDetails = getManagementStyles();

    for (let x = 0; x < mangementStyleDetails.length; x++){
        if (parseInt(mangementStyleDetails[x].contract) === parseInt(managestyle)){
            switch (mangementStyleDetails[x].bonustype) {
                case "speed":
                if (boosttype === mangementStyleDetails[x].bonustype ){
                    if (mangementStyleDetails[x].calctype === "plus"){
                        tempspeed = tempspeed + mangementStyleDetails[x].bonus;
                    }else{
                        tempspeed = tempspeed * mangementStyleDetails[x].bonus;
                    }
                    boostreturn = tempspeed;
                }
                    break;
                case "accel":
                    if (boosttype === mangementStyleDetails[x].bonustype ){
                    if (mangementStyleDetails[x].calctype === "plus"){
                        tempaccel = tempaccel + mangementStyleDetails[x].bonus;
                    }else{
                        tempaccel = tempaccel * mangementStyleDetails[x].bonus;
                    }
                    boostreturn = tempaccel;
                }
                break;
                case "endur":
                    if (boosttype === mangementStyleDetails[x].bonustype ){
                    if (mangementStyleDetails[x].calctype === "plus"){
                        tempendur = tempendur + mangementStyleDetails[x].bonus;
                    }else{
                        tempendur = tempendur * mangementStyleDetails[x].bonus;
                    }
                    boostreturn = tempendur;
                }
                break;
                default:
                //leave as all default
                break;
            }
            break;
        }
    }
    return parseInt(boostreturn);
    

}

const getHydrolyteByRacerReg = (racercnt) => {
    let hydroInfo = {};
    let currHydro = 0;
    let nextTier = 0;
    let nextHydro = 0;

    if (racercnt < 10){
        currHydro = 0;
        nextTier = 10 - racercnt;
        nextHydro = 1;
    }else if (racercnt >= 10 && racercnt < 20){
        currHydro = 1;
        nextTier = 20 - racercnt;
        nextHydro = 2;
    }else if (racercnt >= 20 && racercnt < 30){
        currHydro = 3;
        nextTier = 30 - racercnt;
        nextHydro = 2;
    }else if (racercnt >= 30 && racercnt < 40){
        currHydro = 5;
        nextTier = 40 - racercnt;
        nextHydro = 3;
    }else if (racercnt >= 40 && racercnt < 50){
        currHydro = 8;
        nextTier = 50 - racercnt;
        nextHydro = 3;
    }else if (racercnt >= 50 && racercnt < 60){
        currHydro = 11;
        nextTier = 60 - racercnt;
        nextHydro = 3;
    }else if (racercnt >= 60 && racercnt < 70){
        currHydro = 14;
        nextTier = 70 - racercnt;
        nextHydro = 4;
    }else if (racercnt >= 70 && racercnt < 80){
        currHydro = 18;
        nextTier = 80 - racercnt;
        nextHydro = 4;
    }if (racercnt >= 80){
        currHydro = 22;
        nextTier = 0;
        nextHydro = 0;
    }

    hydroInfo.currhydro = currHydro;
    hydroInfo.nexttier = nextTier;
    hydroInfo.nexthydro = nextHydro;

    return hydroInfo;
}

export {getCurrentMatic, getPearlBalance, getRacers, getAccountName, checkAccountName,getNFTSByOwner, getNFTSByContractandOwner,checkAddress, getNFTS, checkPearlApproval, setPearlBalance, checkNFTOwner,updateName, getEORMintInfo, mintEORNFTS,  getTierByCollection, getMintBalance, getRegistrationStatus, getStakedRacers, getCurrentWeek, getRaceTypes, stakeRacers, getSetCoaches, setLeagueCoach, setRoles, unstakeRacers, moveRacers,getCoachMintInfo, mintCoachNFTS, updateShortName, getTransferFaves, updateAllowTransfers, checkTransferStatus, updateTransferFavorite, checkAllTransferStatus, setAllTransferStatus,transferNfts, transferOneCoach, transferOneRacer, checkSignature, setSignature, getManagementStyles, setLeagueManagement, getManagementStyleBonuses,getHydrolyteByRacerReg,getStoredHydro,assignHydro  }